import { Component, inject } from '@angular/core'

import { BannerComponent, TypographyComponent } from '@hyperkit'

import { PackageViewService } from '../../../../../services/reader/package-view.service'

export interface TableColumn {
  header: string
  field: keyof Record<string, unknown>
}

@Component({
  standalone: true,
  selector: 'default-query-logic-tab',
  imports: [BannerComponent, TypographyComponent],
  templateUrl: './query-logic-tab.component.html',
  styleUrl: './query-logic-tab.component.scss',
})
export class QueryLogicTabComponent {
  private readonly pkgView = inject(PackageViewService)

  /** The columns to display in order */
  readonly columns: TableColumn[] = [
    { header: 'Condition', field: 'condition' },
    { header: 'Field', field: 'field' },
    { header: 'Value', field: 'value' },
  ]

  /** The array of rows to render */
  readonly rows = this.pkgView.queryTable
}
